function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("line", {
  id: "Line_1",
  "data-name": "Line 1",
  x1: 21.212,
  transform: "translate(29 29.5)",
  fill: "none",
  stroke: "#fff",
  strokeWidth: 1
});

var _ref3 = /*#__PURE__*/React.createElement("line", {
  id: "Line_2",
  "data-name": "Line 2",
  x1: 21.212,
  transform: "translate(29 36.5)",
  fill: "none",
  stroke: "#fff",
  strokeWidth: 1
});

var _ref4 = /*#__PURE__*/React.createElement("line", {
  id: "Line_3",
  "data-name": "Line 3",
  x1: 21.212,
  transform: "translate(29 43.5)",
  fill: "none",
  stroke: "#fff",
  strokeWidth: 1
});

var SvgMenuBar = function SvgMenuBar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21.212,
    height: 15,
    viewBox: "0 0 21.212 15",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Menu_Bar",
    "data-name": "Menu Bar",
    transform: "translate(-29 -29)",
    style: {
      isolation: "isolate"
    }
  }, _ref2, _ref3, _ref4));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMenuBar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/MenuBar.ec6fe8fb.svg";
export { ForwardRef as ReactComponent };